import AllWorks from "components/Works/AllWorks/AllWorks";
import Hero from "components/Works/Hero/Hero";
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
export default function WorksPage() {
  const { t } = useTranslation();
  
  return (
    <div>
      <Helmet>
        <title>{t("Title.portfolio")}</title>
        <meta
          name="description"
          content="ヱビス株式会社ウェブサイト開発実績。ヱビスはスマートフォンやIoT、クラウドを活用したサービスを提供する会社です。"
        />
        <link rel="canonical" href="https://ebisuinc.jp/works/" />
      </Helmet>
      <Hero />
      <AllWorks />
    </div>
  );
}
